export default __webpack_public_path__ + "static/media/T2Comedor.1b9796bc.jpg";